import React from 'react';
import { formatSubtext } from '../../../utils/formatSubtext';
import { ObservableField as Field, useForm } from '../../ObservableForm';
import { FilesFieldFragment } from './FilesField.generated';
import FilesView from './View';
import AttachmentUploader from './uploader/AttachmentUploader';

export interface UploaderConfig {
    requestAccessKey: string;
    bucket: string;
    requestEndpoint: string;
    signatureEndpoint: string;
    keyPrefix: string;
    signatureVersion: number;
    region: string;
    allowedFileTypes?: string[];
}

export type Props = FilesFieldFragment & {
    uploader: UploaderConfig;
};

export function Edit({
    id: name,
    label,
    uploader,
    subtextLink,
    subtext,
    tooltip,
    required,
    allowedFileTypes,
}: Props) {
    const form = useForm();
    const uploaderWithFileTypes = { ...uploader };

    uploaderWithFileTypes.allowedFileTypes = allowedFileTypes || undefined;

    return (
        <Field
            form={form}
            name={name}
            title={label}
            tooltip={tooltip ? tooltip : undefined}
            required={required || false}
            message={formatSubtext(subtext, subtextLink)}
            render={() => (
                <AttachmentUploader uploader={uploaderWithFileTypes} {...form.attach(name)} />
            )}
        />
    );
}

export function View({ filesValue }: Props) {
    return <FilesView files={filesValue} />;
}

export function HasValue({ filesValue }: Props): boolean {
    return filesValue.length !== 0;
}

export function getValue({ filesValue }: Props) {
    return filesValue;
}
